import React from 'react'
import { qualifications } from './educationInfo'
import './experience.css';
import { experiences } from './experienceInfo'
import {
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBCardHeader
} from 'mdb-react-ui-kit';
import { Fade, Slide } from 'react-awesome-reveal';
import {TbBulbFilled} from 'react-icons/tb';



export const EducationCard = (props) => {
  console.log(props);
  return (
    <div className="eduCard" style={{width:'100%'}}>
        <MDBCard className='mdbcard' style={{width:'80%', backgroundColor:'rgb(27, 23, 36)', color:'white'}}>
        <MDBCardHeader>{props.item.year}</MDBCardHeader>
        <MDBCardBody>
          <MDBCardTitle>{props.item.educationLevel}</MDBCardTitle>
          <MDBCardText>{props.item.schoolName}</MDBCardText>
        </MDBCardBody>
      </MDBCard>
    </div>
  )
}

export const ExperienceCard = (props) => {
  return (
    <div className="exCard" style={{width:'100%'}}>
      <MDBCard style={{width:'80%', backgroundColor:'rgb(27, 23, 36)', color:'white'}}>
        <MDBCardHeader>{props.item.role}</MDBCardHeader>
        <MDBCardBody>
          <MDBCardTitle>{props.item.at}</MDBCardTitle>
          <MDBCardText>{props.item.works}</MDBCardText>
        </MDBCardBody>
      </MDBCard>
    </div>
  )
}

function Experience() {
  return (
    <div className="experienceSection" style={{minHeight:'100vh',display:'flex', justifyContent:'center', alignItems:'center'}}>
      <div className='tempEx' style={{display:'flex', width:'100vw',flexWrap:'wrap',margin:'auto'}}>
        <div className='education col-sm-12 col-md-6'>
            <h1 style={{color:'yellow', margin:"1rem"}}>Education</h1>
            <Fade cascade>
              <Slide cascade direction='right'>
            <div className='educationBox'>
              {qualifications.map((qualification) => <EducationCard item = {qualification} />
              )}
            </div>
            </Slide>
            </Fade>
        </div>
        <div className='experience col-sm-12 col-md-6'>
            <h1 style={{color:'yellow', textAlign:'right', margin:"1rem"}}>Experience</h1>
            <Fade cascade>
              <Slide cascade direction='left'>
            <div className='educationBox'>
              {experiences.map((experience)  => <ExperienceCard item = {experience} />
              )}
            </div>
            </Slide>
            </Fade>
        </div>
      </div>
    </div>
  )
}

export default Experience
